import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function Login() {
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // In this flow, username is the email, and password is the PIN
      await login(email, pin);
      const params = new URLSearchParams(window.location.search);
      const redirectTo = params.get('redirectTo');
      navigate(redirectTo || '/events');
    } catch {
      toast.error('Invalid credentials');
    }
  };

  return (
    <div className="container animate-fade-in" style={{ maxWidth: '400px', marginTop: '60px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Welcome Back</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', color: '#4b5563', fontWeight: '500' }}>Email Address</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', color: '#4b5563', fontWeight: '500' }}>4-Digit PIN</label>
          <input
            type="password"
            placeholder="Enter your PIN"
            value={pin}
            onChange={e => setPin(e.target.value)}
            maxLength="4"
            required
            style={{ letterSpacing: '2px' }}
          />
        </div>
        <button type="submit" style={{ width: '100%', marginTop: '10px' }}>
          Login
        </button>
      </form>
      <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#666' }}>
        Don't have an account? <a href="/signup" style={{ color: '#6366f1', fontWeight: 'bold' }}>Sign up here</a>
      </div>
    </div>
  );
}
